// extracted by mini-css-extract-plugin
export default {"toastLocation":"style_toastLocation__NekD6"};